<app-header (contactClick)="scrollToFooter()"></app-header>
<div id="outlet-container">
  <router-outlet></router-outlet>
</div>
<app-footer #footerRef></app-footer>
